import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ContactService } from 'api-services/contact.service';
import { EmailNotification, EmailNotificationDetail } from 'models/admin-dashboard/admin-dashboard-request.model';
import { SharedService } from 'services';

@Component({
  selector: 'app-email-notification',
  templateUrl: './email-notification.component.html',
  styleUrls: ['./email-notification.component.css']
})
export class EmailNotificationComponent implements OnInit {
  @Input() emailNotificationLogId;
  EmailNotificationDetails: EmailNotificationDetail[] = []
  constructor(public activeModal: NgbActiveModal, private contactService: ContactService, private sharedService: SharedService) { }

  ngOnInit(): void { 
    this.contactService.producerLicenseExpireEmailNotificationDetails(this.emailNotificationLogId).subscribe
    ((res: EmailNotificationDetail[]) => 
      {
        this.EmailNotificationDetails = res.map(el => ({
          ...el,
          sentOn: this.sharedService.convertUTCTimeToLocalTime(el.sentOn)
        }))
      });
  }

  close() {
    this.activeModal.close(true);
  }
}
